import { render, staticRenderFns } from "./NoticePopup.vue?vue&type=template&id=042882c0"
import script from "./NoticePopup.vue?vue&type=script&lang=js"
export * from "./NoticePopup.vue?vue&type=script&lang=js"
import style0 from "./NoticePopup.vue?vue&type=style&index=0&id=042882c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports